
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(badge, badgeIndex) {
                    return _createElement('div', {
                        'className': 'badge cm_badge cm_badge__' + this.toKebabCase(badge),
                        'key': badge
                    }, '\n          ', badge, '\n        ');
                }
                function scopeColorArrColorImageUrl2(colorOption, colorOptionIndex) {
                    var colorArr = colorOption.split('|');
                    var color = colorArr[0];
                    var image = colorArr[1];
                    var url = colorArr[2];
                    return [_createElement('a', {
                            'className': 'product-color-swatch swatch-element color' + (colorOptionIndex >= 4 ? ' hidden' : ''),
                            'data-product-id': 'product-' + this.id,
                            'data-option-image': image,
                            'title': color,
                            'href': url,
                            'key': '34191'
                        }, _createElement('img', { 'src': image }))];
                }
                function repeatColorOption3(colorOption, colorOptionIndex, colorArr, color, image, url) {
                    return scopeColorArrColorImageUrl2.apply(this, [
                        colorOption,
                        colorOptionIndex
                    ]);
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatI5(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                return _createElement('div', { 'className': 'halo-item' }, _createElement('div', {
                    'className': 'product-card layout-1',
                    'data-product-id': 'product-' + this.id,
                    'data-id': this.id
                }, _createElement('div', { 'className': 'product-image' }, _createElement('a', {
                    'className': 'product_wishlist wishlist',
                    'href': '#',
                    'aria-label': 'wishlist',
                    'data-icon-wishlist': true,
                    'data-product-handle': this.handle,
                    'data-id': this.id
                }, _createElement('svg', { 'className': 'icon' }, _createElement('use', { 'xlinkHref': '#icon-heart' }))), _createElement.apply(this, [
                    'div',
                    { 'className': 'product_badges' },
                    !this.out_of_stock && this.on_sale ? _createElement('div', {
                        'className': 'badge sale-badge sale-badge-2',
                        'key': '441'
                    }, '\n          -', this.calcDiscount(this.price, this.compare_at_price), '%\n        ') : null,
                    this.out_of_stock ? _createElement('div', {
                        'className': 'badge soldOut-badge',
                        'key': '626'
                    }, _translate(`product_out_of_stock`)) : null,
                    this._badges ? _map(this._badges, repeatBadge1.bind(this)) : null
                ]), _createElement('a', {
                    'className': 'product-link' + (this.image2 ? ' image-swap' : ''),
                    'href': this.url,
                    'aria-label': 'link'
                }, _createElement('img', {
                    'className': (this.image2 ? 'image-one ' : '') + 'lazyautosizes lazyloaded',
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'onError': this.onImageError
                }), this.image2 ? _createElement('img', {
                    'className': 'image-two lazyautosizes lazyloaded',
                    'src': this.resizeImage(this.image2),
                    'onError': e => this.onImageError(e, 'image2'),
                    'key': '1236'
                }) : null), _createElement('a', {
                    'className': 'product-quickview',
                    'aria-label': 'quickview',
                    'id': this.handle,
                    'data-quickview': true,
                    'aria-describedby': 'a11y-external-message'
                }, '\n        ', _translate(`product_quick_view`), '\n      '), _createElement('div', { 'className': 'product-action' }, _createElement('form', {
                    'action': '/cart/add',
                    'method': 'post',
                    'className': 'variants',
                    'id': 'list-product-form-' + this.id,
                    'data-id': 'product-actions-' + this.id,
                    'encType': 'multipart/form-data'
                }, this.variant_ids.length > 1 ? [_createElement('a', {
                        'className': 'btn product-btn',
                        'href': this.url,
                        'aria-label': 'button',
                        'key': '18191'
                    }, '\n              ', this.out_of_stock ? _translate(`product_out_of_stock`) : _translate(`product_select_options`), '\n            ')] : null, this.variant_ids.length === 1 ? [
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'id',
                        'value': this.variant_ids,
                        'key': '21131'
                    }),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'quantity',
                        'value': this.set_qty || 1,
                        'key': '21133'
                    }),
                    this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                        'type': 'hidden',
                        'name': 'properties[Fitment]',
                        'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                        'key': '21135'
                    }) : null,
                    _createElement('button', {
                        'data-btn-addtocart': true,
                        'className': 'btn product-btn',
                        'type': 'submit',
                        'data-form-id': '#list-product-form-' + this.id,
                        'disabled': this.out_of_stock,
                        'key': '21137'
                    }, this.out_of_stock ? [_translate(`product_out_of_stock`)] : null, !this.out_of_stock ? [
                        _translate(`product_add_to_cart`),
                        this.set_qty ? ` ${ _translate(`product_set_of`, {  count: this.set_qty  }) }` : ''
                    ] : null)
                ] : null))), _createElement('div', { 'className': 'product-content' }, _createElement('div', { 'className': 'product-detail' }, this.product_colors && this.product_colors.length > 1 ? _createElement('div', {
                    'className': 'product-color-swatch-container',
                    'key': '3164'
                }, _createElement('span', { 'className': 'form-label' }, 'Color', _createElement('em', {}, '*')), _createElement.apply(this, [
                    'div',
                    { 'className': 'product-color-swatch-list-container swatch' },
                    _map(this.product_colors, repeatColorOption3.bind(this)),
                    this.product_colors.length > 5 ? [_createElement('a', {
                            'className': 'product-color-swatch show-more',
                            'key': '39181'
                        }, '+', this.product_colors.length - 4)] : null
                ])) : null, this.vendor && this.vendor_url ? _createElement('a', mergeProps({
                    'className': 'product-vendor',
                    'aria-label': 'vendor',
                    'href': this.vendor_url,
                    'title': this.removeHTML(this.vendor),
                    'key': '4133'
                }, { dangerouslySetInnerHTML: { __html: typeof this.vendor === 'undefined' ? '' : this.vendor } })) : null, _createElement('a', {
                    'className': 'product-title',
                    'href': this.url,
                    'aria-label': 'product-title'
                }, this.view !== '1' ? [
                    this.sku ? _createElement('span', mergeProps({
                        'className': 'product-title-sku',
                        'key': '45081'
                    }, { dangerouslySetInnerHTML: { __html: typeof this.sku === 'undefined' ? '' : this.sku } })) : null,
                    '\n            ',
                    ' ',
                    '\n          '
                ] : null, this.product_type ? _createElement('span', mergeProps({
                    'className': 'product-title-code',
                    'key': '4803'
                }, { dangerouslySetInnerHTML: { __html: typeof this.product_type === 'undefined' ? '' : this.product_type } })) : null), _createElement('div', { 'className': 'product-price' + (this.on_sale && !this.price_varies ? ' price--on-sale' : '') }, this.on_sale && !this.price_varies ? _createElement('span', {
                    'className': 'price-item price-item--regular',
                    'key': '5151'
                }, _createElement('span', { 'className': 'money' }, this.formatPrice(this.compare_at_price))) : null, _createElement('span', { 'className': 'price-item ' + (this.on_sale && !this.price_varies ? 'price-item--sale' : 'price-item--regular') }, this.price_varies ? _createElement('span', { 'key': '5505' }, _translate(`price_from`), ' ') : null, _createElement('span', { 'className': 'money' }, this.formatPrice(this.min_price || this.price))), this.set_qty && !this.price_varies ? _createElement('div', {
                    'className': 'price-item price-item--set',
                    'key': '5689'
                }, '\n            ', _translate(`product_set_of`, {  count: this.set_qty  }), ': ', this.formatPrice(this.price * this.set_qty), '\n          ') : null), this.view === '1' ? _createElement('div', {
                    'className': 'product-details',
                    'key': '5938'
                }, this.Position ? _createElement('div', {
                    'className': 'product-position',
                    'key': '6014'
                }, 'Position: ', _createElement('span', {}, this.Position)) : null, this.Notes ? _createElement('div', {
                    'className': 'product-notes',
                    'key': '6121'
                }, 'Notes: ', _createElement('span', {}, this.Notes)) : null, _createElement('div', { 'className': 'product-detail-additional' }, _createElement('div', { 'className': 'product-sku' }, 'SKU: ', _createElement('span', { dangerouslySetInnerHTML: { __html: typeof this.sku === 'undefined' ? '' : this.sku } })), _createElement('div', { 'className': 'product-availability' }, '\n              Availability:\n              ', _createElement('span', {}, '\n                ', this.stock.includes('In-stock Only') ? 'In stock' : this.stock.includes('Available') ? 'Available' : _translate(`product_out_of_stock`), '\n              ')))) : null, [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '68060'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI5.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                    ]) : null], this.price ? _createElement('p', {
                    'className': 'affirm-as-low-as',
                    'data-amount': this.price * 100,
                    'data-affirm-type': 'logo',
                    'data-affirm-color': 'blue',
                    'key': '7212'
                }) : null, this.body_html && this.view === '1' ? _createElement('div', mergeProps({
                    'className': 'product-description',
                    'key': '7352'
                }, { dangerouslySetInnerHTML: { __html: typeof this.body_html === 'undefined' ? '' : this.body_html } })) : null), _createElement('div', { 'className': 'product-actions' }, _createElement('form', {
                    'action': '/cart/add',
                    'method': 'post',
                    'className': 'variants',
                    'id': 'list-product-form-' + this.id,
                    'data-id': 'product-actions-' + this.id,
                    'encType': 'multipart/form-data'
                }, this.variant_ids.length > 1 || this.ProductScope === 'master' ? [_createElement('a', {
                        'className': 'btn product-btn',
                        'href': this.url,
                        'aria-label': 'button',
                        'key': '78061'
                    }, '\n              ', this.out_of_stock ? _translate(`product_out_of_stock`) : _translate(`product_select_options`), '\n            ')] : null, this.variant_ids.length === 1 && (!this.ProductScope || this.ProductScope === 'child') ? [
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'id',
                        'value': this.variant_ids,
                        'key': '81441'
                    }),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'quantity',
                        'value': this.set_qty || 1,
                        'key': '81443'
                    }),
                    _createElement('button', {
                        'data-btn-addtocart': true,
                        'className': 'btn product-btn',
                        'type': 'submit',
                        'data-form-id': '#list-product-form-' + this.id,
                        'disabled': this.out_of_stock,
                        'key': '81445'
                    }, this.out_of_stock ? [_translate(`product_out_of_stock`)] : null, !this.out_of_stock ? [
                        _translate(`product_add_to_cart`),
                        this.set_qty ? ` ${ _translate(`product_set_of`, {  count: this.set_qty  }) }` : ''
                    ] : null)
                ] : null), _createElement('button', {
                    'className': 'wishlist btn btn--secondary',
                    'data-icon-wishlist': true,
                    'data-product-handle': this.handle,
                    'data-id': this.id
                }, _createElement('span', { 'className': 'add' }, 'Add to Wish List'), _createElement('span', { 'className': 'remove' }, 'Remove Wish List'))))));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products container' }, _createElement('div', { 'className': 'section-header text-left cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []